/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BeianNumbersResp,
  ConfigValueResp,
  LoginDefaultRouteResp,
  RegistrationStatusResp,
  SysSetConfigBody,
} from "./system-config-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const SysGetRegistrationStatus = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<RegistrationStatusResp>(
    { url: `/intl/system/config/client/registration`, method: "GET", signal },
    options,
  );
};

export const getSysGetRegistrationStatusQueryKey = () => {
  return [`/intl/system/config/client/registration`] as const;
};

export const getSysGetRegistrationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSysGetRegistrationStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof SysGetRegistrationStatus>>
  > = ({ signal }) => SysGetRegistrationStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SysGetRegistrationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof SysGetRegistrationStatus>>
>;
export type SysGetRegistrationStatusQueryError = unknown;

export function useSysGetRegistrationStatus<
  TData = Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
          TError,
          Awaited<ReturnType<typeof SysGetRegistrationStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetRegistrationStatus<
  TData = Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
          TError,
          Awaited<ReturnType<typeof SysGetRegistrationStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetRegistrationStatus<
  TData = Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSysGetRegistrationStatus<
  TData = Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetRegistrationStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSysGetRegistrationStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const SysGetLoginDefaultRoute = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LoginDefaultRouteResp>(
    {
      url: `/intl/system/config/client/login-default-route`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSysGetLoginDefaultRouteQueryKey = () => {
  return [`/intl/system/config/client/login-default-route`] as const;
};

export const getSysGetLoginDefaultRouteQueryOptions = <
  TData = Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSysGetLoginDefaultRouteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>
  > = ({ signal }) => SysGetLoginDefaultRoute(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SysGetLoginDefaultRouteQueryResult = NonNullable<
  Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>
>;
export type SysGetLoginDefaultRouteQueryError = unknown;

export function useSysGetLoginDefaultRoute<
  TData = Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
          TError,
          Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetLoginDefaultRoute<
  TData = Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
          TError,
          Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetLoginDefaultRoute<
  TData = Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSysGetLoginDefaultRoute<
  TData = Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetLoginDefaultRoute>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSysGetLoginDefaultRouteQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const SysGetBeianNumbers = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<BeianNumbersResp>(
    { url: `/intl/system/config/client/beian-numbers`, method: "GET", signal },
    options,
  );
};

export const getSysGetBeianNumbersQueryKey = () => {
  return [`/intl/system/config/client/beian-numbers`] as const;
};

export const getSysGetBeianNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof SysGetBeianNumbers>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof SysGetBeianNumbers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSysGetBeianNumbersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof SysGetBeianNumbers>>
  > = ({ signal }) => SysGetBeianNumbers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof SysGetBeianNumbers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SysGetBeianNumbersQueryResult = NonNullable<
  Awaited<ReturnType<typeof SysGetBeianNumbers>>
>;
export type SysGetBeianNumbersQueryError = unknown;

export function useSysGetBeianNumbers<
  TData = Awaited<ReturnType<typeof SysGetBeianNumbers>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetBeianNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetBeianNumbers>>,
          TError,
          Awaited<ReturnType<typeof SysGetBeianNumbers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetBeianNumbers<
  TData = Awaited<ReturnType<typeof SysGetBeianNumbers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetBeianNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetBeianNumbers>>,
          TError,
          Awaited<ReturnType<typeof SysGetBeianNumbers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetBeianNumbers<
  TData = Awaited<ReturnType<typeof SysGetBeianNumbers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetBeianNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSysGetBeianNumbers<
  TData = Awaited<ReturnType<typeof SysGetBeianNumbers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof SysGetBeianNumbers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSysGetBeianNumbersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const SysGetConfig = (
  key: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ConfigValueResp>(
    { url: `/intl/system/config/${key}`, method: "GET", signal },
    options,
  );
};

export const getSysGetConfigQueryKey = (key: string) => {
  return [`/intl/system/config/${key}`] as const;
};

export const getSysGetConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof SysGetConfig>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof SysGetConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSysGetConfigQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof SysGetConfig>>> = ({
    signal,
  }) => SysGetConfig(key, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: key !== null && key !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof SysGetConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SysGetConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof SysGetConfig>>
>;
export type SysGetConfigQueryError = unknown;

export function useSysGetConfig<
  TData = Awaited<ReturnType<typeof SysGetConfig>>,
  TError = unknown,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof SysGetConfig>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetConfig>>,
          TError,
          Awaited<ReturnType<typeof SysGetConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetConfig<
  TData = Awaited<ReturnType<typeof SysGetConfig>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof SysGetConfig>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof SysGetConfig>>,
          TError,
          Awaited<ReturnType<typeof SysGetConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSysGetConfig<
  TData = Awaited<ReturnType<typeof SysGetConfig>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof SysGetConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSysGetConfig<
  TData = Awaited<ReturnType<typeof SysGetConfig>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof SysGetConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSysGetConfigQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const SysSetConfig = (
  key: string,
  sysSetConfigBody?: SysSetConfigBody,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/system/config/${key}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: sysSetConfigBody,
      signal,
    },
    options,
  );
};

export const getSysSetConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof SysSetConfig>>,
    TError,
    { key: string; data?: SysSetConfigBody },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof SysSetConfig>>,
  TError,
  { key: string; data?: SysSetConfigBody },
  TContext
> => {
  const mutationKey = ["sysSetConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof SysSetConfig>>,
    { key: string; data?: SysSetConfigBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return SysSetConfig(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SysSetConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof SysSetConfig>>
>;
export type SysSetConfigMutationBody = SysSetConfigBody | undefined;
export type SysSetConfigMutationError = unknown;

export const useSysSetConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof SysSetConfig>>,
      TError,
      { key: string; data?: SysSetConfigBody },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof SysSetConfig>>,
  TError,
  { key: string; data?: SysSetConfigBody },
  TContext
> => {
  return useMutation(getSysSetConfigMutationOptions(options), queryClient);
};
